module.exports = __webpack_public_path__ + "static/skeleton-f8baf3c48bd673800048e6b71ea1fa5b.jpg";